import React, { useEffect, useState } from "react";
import { observer, useObserver } from "mobx-react-lite";
import { ProjectDirectoryViewModel } from "./ProjectDirectoryViewModel";
import { ProjectDirectoryModel } from "./ProjectDirectoryModel";
import { DarwinInput } from "Globals/Styles/Control/DarwinInput";
import { AcceptButton } from "Globals/Styles/Control/Buttons";
import { Box, Grid, Typography } from "@material-ui/core";
import { CustomHr } from "../CustomComponents";
import { ProjectDirectoryList } from "./ProjectDirectoryList";
import OrangeOpenImg from "Content/OrangePlus.svg";
import OrangeCloseImg from "Content/OrangeCross.svg";

interface IProjectDirectoryViewProps {
    viewModel: ProjectDirectoryViewModel;
}

export const ProjectDirectoryView: React.FC<IProjectDirectoryViewProps> = observer(({ viewModel }) => {
    const [showAddForm, setShowAddForm] = useState(false);

    const handleAddEntry = async () => {
        if (await viewModel.isModelValid()) {
            const result = await viewModel.addDirectoryEntry(viewModel.model);
            if (result.wasSuccessful) {
                viewModel.model.clear();
                setShowAddForm(false);
            }
        } else {
            console.log("Directory validation failed.");
        }
    };

    const handleUpdateEntry = async (entry: ProjectDirectoryModel) => {
        const result = await viewModel.updateDirectoryEntry(entry);
        if (result.wasSuccessful) {
            viewModel.model.clear();
        }
    };

    const handleDeleteEntry = async (entryId: string) => {
        await viewModel.deleteDirectoryEntry(entryId);
    };

    return useObserver(() => (
        <Box style={{ width: "100%", flexDirection: "column" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h2">Project Directory</Typography>
                <Box display="flex" alignItems="center" style={{ cursor: "pointer" }} onClick={() => setShowAddForm(!showAddForm)}>
                    <img
                        src={showAddForm ? OrangeCloseImg : OrangeOpenImg}
                        alt={showAddForm ? "Close add directory entry" : "Open Add Directory Entry"}
                        style={{ marginRight: "8px" }}
                    />
                    <Typography variant="body1">Add Person</Typography>
                </Box>
            </Box>
            <CustomHr padding={"10px 0"} />

            {showAddForm && (
                <Box
                    style={{
                        marginBottom: "20px",
                        padding: "20px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        width: "100%",
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="First Name"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="firstName"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Last Name"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="lastName"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Company"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="company"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Role"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="role"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Email Address"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="emailAddress"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Phone Number"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="phoneNumber"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                <AcceptButton onClick={handleAddEntry} style={{ marginRight: "10px" }} disabled={viewModel.IsLoading}>
                                    Save
                                </AcceptButton>
                                <AcceptButton onClick={() => setShowAddForm(false)}>Cancel</AcceptButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}

            <Box style={{ width: "100%" }}>
                <ProjectDirectoryList entries={viewModel.directoryEntries} onUpdate={handleUpdateEntry} onDelete={handleDeleteEntry} isLoading={viewModel.IsLoading} />
            </Box>
        </Box>
    ));
});
